<template>
  <review-status
    :state="state"
    :message="message"
  />
</template>

<script>
import ReviewStatus from "../../global/ReviewStatus.vue";

export default {
  components: {
    ReviewStatus
  },
  props: {
    decision: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    keywordCount: {
      type: Number,
      default: 0,
    },
    pendingMessage: {
      type: String,
      default: 'Pending review, this may take a few moments.',
    },
    unreviewedMessage: {
      type: String,
      default: "This page's keywords have not been reviewed yet. Please press the 'Review Sitemap' button at the bottom of the screen.",
    }
  },
  computed: {
    state() {
      return this.decision || 'unreviewed';
    },
    message() {
      switch (this.state) {
        case 'good':
        case 'bad':
          return this.description;
        case 'unreviewed':
          return this.keywordCount > 0
            ? this.unreviewedMessage
            : 'This page has no keywords assigned, assign keywords to perform a review.';
        default:
          return this.pendingMessage;
      }
    }
  }
}
</script>
